import constants from '../constants.js';

const CompanyReferenceConfigId = {
  displayName: 'Id',
  dataAt: 'Id',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const DebtorIdentifier = {
  displayName: 'DebtorIdentifier',
  dataAt: 'DebtorIdentifier',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: false
};

const ListId = {
  displayName: 'ListId',
  dataAt: 'ListId',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: false
};

const FtpHost = {
  displayName: 'Ftp Host',
  dataAt: 'FtpHost',
  disabled: false,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const FtpPort = {
  displayName: 'Ftp Port',
  dataAt: 'FtpPort',
  disabled: false,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const FtpUserName = {
  displayName: 'Ftp User Name',
  dataAt: 'FtpUserName',
  disabled: false,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const FtpPassword = {
  displayName: 'Ftp Password',
  dataAt: 'FtpPassword',
  disabled: false,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const IsFtp = {
  displayName: 'Use Secure Ftp (SFtp)',
  dataAt: 'IsSFtp',
  disabled: false,
  default: false,
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const TestFtpConnection = {
    disabled: false,
    displayAs:constants.DISPLAY_AS.TEST_FTP_CONNECTION,
    endPointController: "api/companyreferenceconfig/checkftp"
};

const FileName = {
  displayName: 'File Name (csv only)',
  dataAt: 'FileName',
  disabled: false,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const FilePath = {
  displayName: 'File Path',
  dataAt: 'FilePath',
  disabled: false,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const forceImportNextRun = {
  displayName: 'Force Import Next Run',
  dataAt: 'ForceImportNextRun',
  disabled: false,
  default: false,
  displayAs: constants.DISPLAY_AS.BOOLEAN
};
const alertEmails = {
  displayName: 'Alert Emails (Comma separate emails)',
  dataAt: 'AlertEmails',
  disabled: false,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};
const IsDisabled = {
    displayName: 'Is Config Disabled',
    dataAt: 'IsDisabled',
    disabled: false,
    default: false,
    displayAs: constants.DISPLAY_AS.BOOLEAN
};

const ImportProcessStatusMessage = {
    displayName: 'Status Message',
    dataAt: 'ImportProcessStatusMessage',
    displayAs: constants.DISPLAY_AS.TEXT_INPUT,
    disabled: true
};

const CsvFileRequirementTitle = {
    displayAs: constants.DISPLAY_AS.SUB_HEADING,
    label: "Comma-delimited (csv) files only.  Required format shown below:"
};

const CsvFileFormatLine1 = {
    displayAs: constants.DISPLAY_AS.SUB_HEADING,
    label: "Value,Description  <=== Row 1/Column Header, this is required to be on line 1 in the file"
};

const CsvFileFormatLine2 = {
    displayAs: constants.DISPLAY_AS.SUB_HEADING,
    label: "my value,someDescription  <=== Subsequent data starts on line 2"
};

const CompanyReferenceViewResourceFilename = {
  displayName: "FileName",
  dataAt: "FileName",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};
const CompanyReferenceViewResourceImportProcessAttemptDate = {
  displayName: "ImportProcessAttemptDate",
  dataAt: "ImportProcessAttemptDate",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};
const CompanyReferenceViewResourceImportProcessCompleteDate = {
  displayName: "ImportProcessCompleteDate",
  dataAt: "ImportProcessCompleteDate",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};
const CompanyReferenceViewResourceWasFileFoundOnFtp = {
  displayName: "WasFileFoundOnFtp",
  dataAt: "WasFileFoundOnFtp",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};
const CompanyReferenceViewResourceWasDownloadSuccessful = {
  displayName: "WasDownloadSuccessful",
  dataAt: "WasDownloadSuccessful",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};
const CompanyReferenceViewResourceFileDownloadProgress = {
  displayName: "FileDownloadProgress",
  dataAt: "FileDownloadProgress",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const CompanyReferenceViewResourceProcessAttemptCount = {
  displayName: "ProcessAttemptCount",
  dataAt: "ProcessAttemptCount",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const CompanyReferenceViewResourceWasDataSaveSuccessful = {
  displayName: "WasDataSaveSuccessful",
  dataAt: "WasDataSaveSuccessful",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};
const CompanyReferenceViewResourceErrors = {
  displayName: "Errors",
  dataAt: "Errors",
  displayAs: constants.DISPLAY_AS.TEXT_AREA,
  disabled: false,
  class:"showLineBreaks",
  splitArrayIntoLines: true
};

const FileLogGrid = {
    canAddNew: false,
    canCopyItem: false,
    disableRowClick: false,
    displayName: 'File Processing Logs',
    displayAs: constants.DISPLAY_AS.GRID,
    dataAt: 'FileProcessingLog',
    gridCols: [
        { name: 'File Name', key: 'FileName'},
        { name: 'Import Attempted', key: 'ImportProcessAttemptDate',formater: 'dateLocal'},
        { name: 'Import Completed', key: 'ImportProcessCompleteDate',formater: 'dateLocal'},
        { name: 'File Found on FTP', key: 'WasFileFoundOnFtp'},
        { name: 'Downloaded Successfully', key: 'WasDownloadSuccessful'},
        { name: 'Total % Downloaded', key: 'FileDownloadProgress'},
        { name: 'Saved To Database Successfully', key: 'WasDataSaveSuccessful'},
        { name: 'Import Attempt Count', key: 'ProcessAttemptCount'},
        { name: 'Errors', key: 'Errors'}
    ]
};
const CompanyRefernenceAuditItem = {
  displayAs: constants.DISPLAY_AS.COMPANY_REFEREENCE_AUDIT_ITEM,
  dataAt: 'ImportLogs.$companyRefernenceAuditItem',
};
const auditLogGrid = {
  canAddNew: false,
  canCopyItem: false,
  displayName: 'Audit Logs',
  displayAs: constants.DISPLAY_AS.GRID,
  disableRowClick: true,
  setActiveItemSubItem: true,
  dataAt: 'ImportLogs',
  gridCols: [
      { name: 'CreatedOn', key: 'CreatedOn',formater: 'dateLocal'},
      { name: 'DateStart', key: 'DateStart',formater: 'dateLocal'},
      { name: 'DateEnd', key: 'DateEnd',formater: 'dateLocal'},
      { name: 'ActionType', key: 'ActionType'},
      { name: 'Status', key: 'Status'},
      { name: 'Notes', key: 'Notes'}
  ],
  children: [
    CompanyRefernenceAuditItem
  ],
};

const FileLogGridViewItem = {
  canAddNew: false,
  canCopyItem: false,
  disableRowClick: true,
  displayName: 'File Processing Logs',
  displayAs: constants.DISPLAY_AS.GRID,
  dataAt: 'FileProcessingLog',
  gridCols: [
      { name: 'File Name', key: 'FileName'},
      { name: 'Import Attempted', key: 'ImportProcessAttemptDate',formater: 'dateLocal'},
      { name: 'Import Completed', key: 'ImportProcessCompleteDate',formater: 'dateLocal'},
      { name: 'File Found on FTP', key: 'WasFileFoundOnFtp'},
      { name: 'Downloaded Successfully', key: 'WasDownloadSuccessful'},
      { name: 'Total % Downloaded', key: 'FileDownloadProgress'},
      { name: 'Saved To Database Successfully', key: 'WasDataSaveSuccessful'},
      { name: 'Import Attempt Count', key: 'ProcessAttemptCount'},
      { name: 'Errors', key: 'Errors'}
  ],
  children: [
    CompanyReferenceViewResourceFilename,
    CompanyReferenceViewResourceImportProcessAttemptDate,
    CompanyReferenceViewResourceImportProcessCompleteDate,
    CompanyReferenceViewResourceWasFileFoundOnFtp,
    CompanyReferenceViewResourceWasDownloadSuccessful,
    CompanyReferenceViewResourceFileDownloadProgress,
    CompanyReferenceViewResourceProcessAttemptCount,
    CompanyReferenceViewResourceWasDataSaveSuccessful,
    CompanyReferenceViewResourceErrors
  ]
};
const CompanyReferenceConfigAddResource = {
  displayAs: constants.DISPLAY_AS.ADD_GRID_RESOURCE,
  displayName: 'Company Reference Config',
  data: {
    DebtorIdentifier: '',
    ListId: '',
    FileName: '',
    FilePath: '',
    FtpHost: '',
    FtpPort: null,
    FtpUserName: '',
    FtpPassword: '',
    IsSFtp: false,
    IsDisabled: false,
    ForceImportNextRun: false,
    AlertEmails: ''
  },
  dataAt : '',
  children: [
      DebtorIdentifier,
      ListId,
      FtpHost,
      FtpPort,
      FtpUserName,
      FtpPassword,
      IsFtp,
      TestFtpConnection,
      FileName,
      CsvFileRequirementTitle,
      CsvFileFormatLine1,
      CsvFileFormatLine2,
      FilePath,
      IsDisabled,
      forceImportNextRun,
      alertEmails
  ],
  endpoint: 'CompanyReferenceConfig'
};

const CompanyReferenceConfigEditResource = {
  displayName: 'Company Reference Config',
  iconClass: 'fa-gear',
  dataAt: '',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
      ImportProcessStatusMessage,
      CompanyReferenceConfigId,
      DebtorIdentifier,
      ListId,
      FtpHost,
      FtpPort,
      FtpUserName,
      FtpPassword,
      IsFtp,
      TestFtpConnection,
      FileName,
      CsvFileRequirementTitle,
      CsvFileFormatLine1,
      CsvFileFormatLine2,
      FilePath,
      IsDisabled,
      forceImportNextRun,
      alertEmails,
      FileLogGrid,
      auditLogGrid
  ],
  showBack: false,// Show the Back button. This will hide the other buttons in lbaResource.
  endpoint: 'CompanyReferenceConfig',
  routeParamId: 'companyReferenceConfigId',
  removeParamId: 'companyReferenceConfigId',
  canDelete: true,
  deleteOnBackend: true
};

const CompanyReferenceConfigEditResourceViewLog = {
  displayName: 'Company Reference Config',
  iconClass: 'fa-gear',
  dataAt: '',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    FileLogGridViewItem
  ],
  showBack: false,// Show the Back button. This will hide the other buttons in lbaResource.
  endpoint: 'CompanyReferenceConfig',
  routeParamId: 'companyReferenceConfigId',
  removeParamId: 'companyReferenceConfigId',
  canDelete: false,
  noButtons: true
};

const CompanyReferenceConfigGrid = {
    canAddNew: true,
    displayName: 'Company Reference Config',
    displayAs: constants.DISPLAY_AS.GRID,
    gridItem: CompanyReferenceConfigEditResource,
    gridAdd: CompanyReferenceConfigAddResource,
    gridCols: [
        { name: 'DebtorIdentifier', key: 'DebtorIdentifier' },
        { name: 'ListId', key: 'ListId' },
        { name: 'FileName', key: 'FileName' },
        { name: 'FtpHost', key: 'FtpHost' },
        { name: 'Import Completed Date', key: 'ImportProcessCompleteDate',formater: 'dateLocal' },
        { name: 'Enabled', key: 'IsEnabled' },
        { name: 'Status Message', key: 'ImportProcessStatusMessage' }
    ],
    endpoint: 'CompanyReferenceConfig'
};

const CompanyReferenceConfig = {
  rootNode: true,
  iconClass: 'fa-gear',
  displayName: 'Company Reference Config',
  showTitle: false,
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [
    CompanyReferenceConfigGrid,
    CsvFileRequirementTitle,
    CsvFileFormatLine1,
    CsvFileFormatLine2
  ]
};

export default {
    CompanyReferenceConfig,
    CompanyReferenceConfigGrid,
    CompanyReferenceConfigEditResource,
    CompanyReferenceConfigAddResource,
    CompanyReferenceConfigId,
    CsvFileRequirementTitle,
    CsvFileFormatLine1,
    CsvFileFormatLine2,
    DebtorIdentifier,
    ListId,
    FtpHost,
    FtpPort,
    FtpUserName,
    FtpPassword,
    IsFtp,
    FileName,
    IsDisabled,
    CompanyReferenceConfigEditResourceViewLog
};


// WEBPACK FOOTER //
// ./src/config/fields/companyReferenceConfig.js